export const isOverflown = (e: any) => {
  return e?.scrollHeight && e?.clientHeight ? e.scrollHeight > e.clientHeight : false;
};
